import { gql } from '@apollo/client';

const syncAgentToMyJackQuery = gql`
  mutation ($agentID: Int) {
    syncAgentToMyJack(agentID: $agentID)
  }
`;
export default syncAgentToMyJackQuery;
